export const roles = {
  1: {
    slug: 'super-admin',
    name: 'Super Admin',
  },
  2: {
    slug: 'super-support-staff',
    name: 'Super Support Staff',
  },
  3: {
    slug: 'tenant-owner',
    name: 'Tenant Owner',
  },
  4: {
    slug: 'tenant-staff',
    name: 'Tenant Staff',
  },
  5: {
    slug: 'course-leader',
    name: 'Course Leader',
  },
  6: {
    slug: 'parent',
    name: 'Parent',
  },
  7: {
    slug: 'educational-assistant',
    name: 'Educational Assistant',
  },
  8: {
    slug: 'student',
    name: 'Student',
  },
  9: { slug: 'observer', name: 'Observer' },
};

export const ROLEGROUPS = {
  superadmin: [1, 2],
  staff: [3, 4, 5, 9],
  student: [6, 7, 8],
};

export const isSuperadmin = roleId => ROLEGROUPS.superadmin.some(id => id == roleId);
export const isStaff = roleId => ROLEGROUPS.staff.some(id => id == roleId);
export const isStudent = roleId => ROLEGROUPS.student.some(id => id == roleId);

export const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const timeZones = [
  { value: 'America/New_York', label: '(GMT -5:00) EST' },
  { value: 'America/Los_Angeles', label: '(GMT -8:00) PST' },
  { value: 'America/Denver', label: '(GMT -7:00) MST' },
  { value: 'America/Chicago', label: '(GMT -6:00) CST' },
];

export const defaultColors = [
  '#981B1E',
  '#E07400',
  '#2E7D32',
  '#42A5F5',
  '#5E35B1',
  '#000000',
  '#5B616B',
  '#FCE4EC',
  '#FFF9C4',
  '#E8F5E9',
];
export const defaultSecondaryColors = [
  '#9B0000',
  '#DD2C00',
  '#2E7D32',
  '#00796B',
  '#3F51B5',
  '#7E57C2',
  '#8E24AA',
  '#D81B60',
  '#263238',
  '#546E7A',
];

export const mundoLmsDefaultGray = '#EAEAEA';

export enum QuestionType {
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
  SHORT_ANSWER = 'SHORT_ANSWER',
}
